import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const AB_TASTY_INTEGRATION_NAME = 'ab-tasty';
export const ZAbTastyIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(AB_TASTY_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=ab-tasty.js.map